import React, { Component } from 'react'
import { Button, Popconfirm } from 'antd'
import { DebounceInput } from 'react-debounce-input'

const ButtonGroup = Button.Group

class ProposalSectionLine extends Component {
  renderItem = (item, index) => {
    const {
      moveItemLeft,
      moveItemRight,
      moveItemUp,
      moveItemDown,
      disableMoveItemDown,
      disableMoveItemUp,
      handleDeleteItem,
      handleItemChange,
      sectionIndex
    } = this.props

    return (
      item &&
      !item.markedForDeletion && (
        <li key={item.id || item.tmpId}>
          <div className="row padding10">
            <div className="col-md-9">
              <DebounceInput
                className="ant-input"
                minLength={0}
                debounceTimeout={500}
                value={item.description ? item.description : ''}
                onChange={e => handleItemChange(e, sectionIndex, item.id || item.tmpId)}
                name="description"
              />
            </div>
            <div className="col-md-3 text-right">
              <ButtonGroup>
                <Button
                  icon="left-square"
                  onClick={() => moveItemLeft(index, sectionIndex, item)}
                />
                <Button
                  icon="right-square"
                  onClick={() => moveItemRight(index, sectionIndex, item)}
                />
                <Button
                  disabled={disableMoveItemUp}
                  icon="caret-up"
                  onClick={() => moveItemUp(index, sectionIndex, item)}
                />
                <Button
                  disabled={disableMoveItemDown}
                  icon="caret-down"
                  onClick={() => moveItemDown(index, sectionIndex, item)}
                />
                <Popconfirm
                  title="Are you sure you want to delete this line?"
                  onConfirm={() => handleDeleteItem(index, sectionIndex, item)}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" />
                </Popconfirm>
              </ButtonGroup>
            </div>
          </div>
        </li>
      )
    )
  }

  render() {
    const { item, index } = this.props

    if (item) {
      return this.renderItem(item, index)
    } else {
      return <ol>loading...</ol>
    }
  }
}

export default ProposalSectionLine



// WEBPACK FOOTER //
// ./src/components/ProposalSectionLine.js